var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_103_379)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1218 10.2891L10.5294 11.8857C9.88364 12.5333 8.74746 12.5472 8.08775 11.8857L6.49529 10.2891L0.775879 16.0231C0.988775 16.1214 1.22351 16.1801 1.47305 16.1801H17.1441C17.3936 16.1801 17.6283 16.1215 17.8411 16.0231L12.1218 10.2891Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1444 2.82031H1.47333C1.22378 2.82031 0.989048 2.87902 0.776227 2.9774L6.88782 9.10501C6.88823 9.10542 6.88871 9.10549 6.88912 9.1059C6.88937 9.10616 6.88954 9.1065 6.8896 9.10686L8.87681 11.0993C9.08789 11.3102 9.52987 11.3102 9.74095 11.0993L11.7278 9.1072C11.7278 9.1072 11.7282 9.10631 11.7286 9.1059C11.7286 9.1059 11.7295 9.10542 11.7299 9.10501L17.8414 2.97736C17.6286 2.87895 17.3939 2.82031 17.1444 2.82031ZM-0.0200251 3.75591C-0.130168 3.9785 -0.197754 4.22557 -0.197754 4.49023V14.5098C-0.197754 14.7744 -0.130242 15.0215 -0.0200622 15.2441L5.70926 9.50019L-0.0200251 3.75591ZM18.6377 3.75584L12.9085 9.50019L18.6377 15.2442C18.7479 15.0216 18.8154 14.7745 18.8154 14.5098V4.49023C18.8154 4.2255 18.7479 3.97842 18.6377 3.75584Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_103_379"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.2585,
    height: 19,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.30ad28e51610b3a08cced946bf53d1a6.svg";
export { ForwardRef as ReactComponent };